frappe.ui.form.ControlDatetime = class ControlDatetime extends frappe.ui.form.ControlDate {
	// set_formatted_input(value) {
	// 	if (this.timepicker_only) return;
	// 	if (!this.datepicker) return;
	// 	if (!value) {
	// 		this.datepicker.clear();
	// 		return;
	// 	} else if (value.toLowerCase() === "today") {
	// 		value = this.get_now_date();
	// 	} else if (value.toLowerCase() === "now") {
	// 		value = frappe.datetime.now_datetime();
	// 	}
	// 	value = this.format_for_input(value);
	// 	this.$input && this.$input.val(value);
	// 	this.datepicker.selectDate(frappe.datetime.user_to_obj(value));
	// }



	// get_start_date() {
	// 	this.value = this.value == null ? undefined : this.value;
	// 	let value = frappe.datetime.convert_to_user_tz(this.value);
	// 	return frappe.datetime.str_to_obj(value);
	// }

	// set_date_options() {
	// 	super.set_date_options();
	// 	this.today_text = __("Now");
	// 	let sysdefaults = frappe.boot.sysdefaults;
	// 	this.date_format = frappe.defaultDatetimeFormat;
	// 	let time_format =
	// 		sysdefaults && sysdefaults.time_format ? sysdefaults.time_format : "HH:mm:ss";
	// 	$.extend(this.datepicker_options, {
	// 		timepicker: true,
	// 		timeFormat: time_format.toLowerCase().replace("mm", "ii"),
	// 	});
	// }
	get_now_date() {
		return frappe.datetime.now_datetime(true);
	}


	// parse(value) {
	// 	if (value) {
	// 		// value = frappe.datetime.user_to_str(value, false);

	// 		// if (!frappe.datetime.is_system_time_zone()) {
	// 		// 	value = frappe.datetime.convert_to_system_tz(value, true);
	// 		// }

	// 		if (value == "Invalid date") {
	// 			value = "";
	// 		}
	// 	}
	// 	return value;
	// }

	parse(value) {
		if (value) {
			const selectedDateTime = value; // Assuming the input is in "YYYY-MM-DD HH:MM:SS" format
			const [latinDatePart, latinTimePart] = selectedDateTime.split(' ');
			const [latinYear, latinMonth, latinDay] = latinDatePart.split(/[-/]/).map(Number);
			const [latinHour, latinMinute, latinSecond] = latinTimePart.split(':').map(Number);

			if (latinYear >= 1800) {
				const jalaaliDate = jalaali.toJalaali(latinYear, latinMonth, latinDay);
				const final_jalaaliDate = `${jalaaliDate.jy}-${String(jalaaliDate.jm).padStart(2, "0")}-${String(jalaaliDate.jd).padStart(2, "0")} ${String(latinHour).padStart(2, "0")}:${String(latinMinute).padStart(2, "0")}:${String(latinSecond).padStart(2, "0")}`;
				if (jalaaliDate.jy >= 1000) {
					return value;
				}
			}

			const latinSelectedDateTime = value; // Assuming the input is in "YYYY-MM-DD HH:MM:SS" format
			const [latinDatePart1, latinTimePart1] = latinSelectedDateTime.split(' ');
			const [latinYear1, latinMonth1, latinDay1] = latinDatePart1.split('-').map(Number);
			const [latinHour1, latinMinute1, latinSecond1] = latinTimePart1.split(':').map(Number);
			const gregorianDate = jalaali.toGregorian(latinYear1, latinMonth1, latinDay1);
			const final_gregorianDate = `${gregorianDate.gy}-${String(gregorianDate.gm).padStart(2, "0")}-${String(gregorianDate.gd).padStart(2, "0")} ${String(latinHour).padStart(2, "0")}:${String(latinMinute).padStart(2, "0")}:${String(latinSecond).padStart(2, "0")}`;

			return final_gregorianDate;
		}
	}

	// parse(value) {
	// 	if (value) {
	// 		value = frappe.datetime.user_to_str(value, false);

	// 		if (!frappe.datetime.is_system_time_zone()) {
	// 			value = frappe.datetime.convert_to_system_tz(value, true);
	// 		}

	// 		if (value == "Invalid date") {
	// 			value = "";
	// 		}
	// 	}
	// 	return value;
	// }

	validate(value) {
		const dateRegex = /^\d{4}[-]\d{2}[-]\d{2} \d{2}:\d{2}:\d{2}$/;

		if (value && !dateRegex.test(value)) {
			frappe.msgprint(__("Date must be in format: yyyy-mm-dd hh:mm:ss or yyyy/mm/dd hh:mm:ss"));
			return "";
		}
		return value;
	}

	format_for_input(value) {
		if (!value) return "";

		// Convert to user timezone
		let userDateTime = frappe.datetime.convert_to_user_tz(value);

		// Extract date and time parts
		const [datePart, timePart] = userDateTime.split(" ");
		if (!datePart || !timePart) return value;

		const [gy, gm, gd] = datePart.split("-").map(Number);
		const [hour, minute, second] = timePart.split(":").map(Number);

		if (!gy || !gm || !gd || !hour === undefined) return value;

		// Convert date to Jalaali
		const jDate = jalaali.toJalaali(gy, gm, gd);

		// Format output: Jalaali Date + Time
		const jalaaliDateTime = `${jDate.jy}-${String(jDate.jm).padStart(2, '0')}-${String(jDate.jd).padStart(2, '0')} ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}`;

		return jalaaliDateTime;
	}

	// set_description() {
	// 	const description = this.df.description;
	// 	const time_zone = this.get_user_time_zone();

	// 	if (!this.df.hide_timezone) {
	// 		// Always show the timezone when rendering the Datetime field since the datetime value will
	// 		// always be in system_time_zone rather then local time.

	// 		if (!description) {
	// 			this.df.description = time_zone;
	// 		} else if (!description.includes(time_zone)) {
	// 			this.df.description += "<br>" + time_zone;
	// 		}
	// 	}
	// 	super.set_description();
	// }

	// get_user_time_zone() {
	// 	return frappe.boot.time_zone ? frappe.boot.time_zone.user : frappe.sys_defaults.time_zone;
	// }

	// set_datepicker() {
	// 	super.set_datepicker();
	// 	if (this.datepicker.opts.timeFormat.indexOf("s") == -1) {
	// 		// No seconds in time format
	// 		const $tp = this.datepicker.timepicker;
	// 		$tp.$seconds.parent().css("display", "none");
	// 		$tp.$secondsText.css("display", "none");
	// 		$tp.$secondsText.prev().css("display", "none");
	// 	}
	// }

	set_datepicker() {
		// alert("frappe.boot.user.persian")
		function persianToLatinDigits(persianText) {
			const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
			const latinDigits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

			let latinText = persianText;
			for (let i = 0; i < 10; i++) {
				const persianDigitRegExp = new RegExp(persianDigits[i], "g");
				latinText = latinText.replace(persianDigitRegExp, latinDigits[i]);
			}

			return latinText;
		}

		this.$input.on("keydown", (e) => {
			if (e.key === " ") {
				e.preventDefault();
				const now = new Date();
				const year = now.getFullYear();
				const month = String(now.getMonth() + 1).padStart(2, "0");
				const day = String(now.getDate()).padStart(2, "0");
				const hour = String(now.getHours()).padStart(2, "0");
				const minute = String(now.getMinutes()).padStart(2, "0");
				const second = String(now.getSeconds()).padStart(2, "0");

				if (frappe.boot.user.language === "fa") {
					const j = jalaali.toJalaali(now);
					this.$input.val(`${j.jy}-${String(j.jm).padStart(2, "0")}-${String(j.jd).padStart(2, "0")} ${hour}:${minute}:${second}`);
				} else {
					this.$input.val(`${year}-${month}-${day} ${hour}:${minute}:${second}`);
				}
				this.$input.trigger("change");
			}
		});

		if (frappe.boot.user.language == 'fa') {
			this.$input.persianDatepicker({
				format: 'YYYY-MM-DD HH:mm:ss',
				// inline:true,
				autoClose: true,
				initialValue: false,
				persianDigit: false,
				// responsive: true,
				calendarType: 'persian',
				toolbox: {
					calendarSwitch: {
						enabled: false
					},
					todayButton: {
						enabled: false
					},
				},
				timePicker: {
					enabled: true
				},
				calendar: {
					persian: {
						locale: 'en',
						leapYearMode: 'astronomical'
					}
				},
				onSelect: () => {
					const selectedDate = this.$input.val();
					if (selectedDate) {
						const [persianDate, time] = selectedDate.split(" "); // Split date and time if available
						const latinSelectedDate = persianToLatinDigits(persianDate);
						const [latinYear, latinMonth, latinDay] = latinSelectedDate.split("-").map(Number);
						const gregorianDate = jalaali.toGregorian(latinYear, latinMonth, latinDay);
						const final_gregorian = `${gregorianDate.gy}-${String(gregorianDate.gm).padStart(2, "0")}-${String(gregorianDate.gd).padStart(2, "0")} ${time || ""}`;
						// alert(final_gregorian)
						this.$input.val(final_gregorian);
						this.$input.trigger("change");
					}
				},
				// onShow: () => {
				// 	this.$input.val("زمان را انتخاب کنید");
				// },
			});
			// ".content, .main-section, .navbar, .no-breadcrumbs"
			// 	$(window).on('mouseenter', () => {
			// 		const selectedDate = this.$input.val();
			// 		const [latinDate, time] = selectedDate.split(" "); // Split date and time if available
			// 		const [latinYear, latinMonth, latinDay] = latinDate.split("-").map(Number);
			// 		if (latinYear >= 1800){
			// 			const jalaaliDate = jalaali.toJalaali(latinYear, latinMonth, latinDay);
			// 			const final_jalaaliDate = `${jalaaliDate.jy}-${String(jalaaliDate.jm).padStart(2, "0")}-${String(jalaaliDate.jd).padStart(2, "0")} ${time || ""}`;
			// 			if (jalaaliDate.jy >= 1000) {
			// 				this.$input.val(final_jalaaliDate);
			// 		}
			// }
			// 	});
		}

		else {
			this.$input.persianDatepicker({
				format: 'YYYY-MM-DD HH:mm:ss',
				// inline:true,
				autoClose: true,
				initialValue: false,
				persianDigit: false,
				calendarType: 'gregorian',
				toolbox: {
					calendarSwitch: {
						enabled: false
					}
				},
				timePicker: {
					enabled: true
				},
				calendar: {
					persian: {
						locale: 'en'
					}
				},
				onSelect: () => {
					const selectedDate = this.$input.val();
					this.$input.val(selectedDate);
					this.$input.trigger("change");
				},
				// onShow: () => {
				// 	this.$input.val("input your time");
				// },
			});
		}
	}


	get_model_value() {
		let value = super.get_model_value();
		if (!value && !this.doc) {
			value = this.last_value;
		}
		return !value ? "" : frappe.datetime.get_datetime_as_string(value);
	}
};
